import app from '../appContext';
import * as tools from '../utils/tools';
import EventEmitter from '../support/eventemitter';

export var UI = function () {
    //No need for this currently. Empty Contructor...eg
};

tools.inherit(UI, EventEmitter, false);        // Inherit the event emitter class so we can raise events...EK

/**
 * This function is used to show an input box and then create the entity based on the name entered...eg
 * @/// <param name="title" type="Object">The title of the input box</param>
 * @/// <param name="message" type="String">The message in the input box</param>
 * @/// <param name="defaultText" type="String">The default text in the input box</param>
 * @/// <param name="blankTextMessage" type="String">The messagebox displayed if the input is blank when ok is pressed. Leave blank if blank values are valid.</param>
 * @/// <param name="OKBtnText" type="String">The button text of the OK button</param>
 * @/// <param name="CancelBtnText" type="String">The button text of the Cancel button</param>
 * @/// <param name="callback" type="function">the callback function</param>
 **/
UI.prototype.showInput = function (title, message, defaultText, blankTextMessage, OKBtnText, CancelBtnText, callbackOK, callbackCancel)  {
    return app.dv.tools.showInputOkCancel(title, message, defaultText, blankTextMessage, OKBtnText, CancelBtnText, callbackOK, callbackCancel);
};
